export const fmt = v => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
export const MESES = ["Janeiro","Fevereiro","Marco","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
export const DIAS  = ["Dom","Seg","Ter","Qua","Qui","Sex","Sab"];

export const STATUS = {
  AGENDADO:    {l:"Agendado",    cor:"var(--z-blue)",     bg:"#dbeafe"},
  EM_EXECUCAO: {l:"Em Execucao", cor:"var(--z-warning-text)", bg:"#fef3c7"},
  CONCLUIDO:   {l:"Concluido",   cor:"var(--z-success-text)", bg:"#dcfce7"},
  CANCELADO:   {l:"Cancelado",   cor:"var(--z-danger-text)",  bg:"#fee2e2"},
};

export const VAZIO = {
  cliente:"", pedido:"", tecnico:"", status:"AGENDADO", tipo_cliente:"CONSUMIDOR",
  data_agendada:"", endereco:"", cep:"", cidade:"", estado:"",
  descricao:"", observacoes:"", valor_mo:"0", valor_materiais:"0", valor_total:"0"
};
